// Subtle premium "response-start" chime using WebAudio — no asset needed.
let ctx = null;
export function playStartChime() {
  try {
    if (localStorage.getItem("aftermind_sound_off") === "1") return;
    if (!ctx) ctx = new (window.AudioContext || window.webkitAudioContext)();
    const t = ctx.currentTime;
    const notes = [880, 1320]; // A5 → E6, short rising
    notes.forEach((f, i) => {
      const o = ctx.createOscillator();
      const g = ctx.createGain();
      o.type = "sine";
      o.frequency.value = f;
      g.gain.setValueAtTime(0, t + i * 0.09);
      g.gain.linearRampToValueAtTime(0.06, t + i * 0.09 + 0.02);
      g.gain.exponentialRampToValueAtTime(0.0001, t + i * 0.09 + 0.18);
      o.connect(g).connect(ctx.destination);
      o.start(t + i * 0.09);
      o.stop(t + i * 0.09 + 0.2);
    });
  } catch {}
}
export function isSoundMuted() { return localStorage.getItem("aftermind_sound_off") === "1"; }
export function setSoundMuted(v) { if (v) localStorage.setItem("aftermind_sound_off", "1"); else localStorage.removeItem("aftermind_sound_off"); }
